import axios from "axios";
import { API_URL } from "../../API/api";
import {
  GET_ALLJOB_SUCCESS,
  GET_JOBLIST_FAIL,
  GET_JOBLIST_REQUEST,
  JOB_DELETE_FAIL,
  JOB_DELETE_REQUEST,
  JOB_DELETE_SUCCESS,
  JOB_POST_FAIL,
  JOB_POST_REQUEST,
  JOB_POST_SUCCESS,
} from "../ActionTypes/jobActionTypes";

const API = API_URL;

export const jobPostAction = (formData) => async (dispatch) => {
  const { company, position, location, contract } = formData;

  try {
    dispatch({ type: JOB_POST_REQUEST });

    const config = {
      headers: {
        "Content-type": "application/json",
      },
    };
    const { data } = await axios.post(`${API}/adminjobpost`, formData, config);

    dispatch({ type: JOB_POST_SUCCESS, payload: data.message });
  } catch (error) {
    dispatch({ type: JOB_POST_FAIL, payload: error.response.data.message || error.message });
  }
};

export const getJobListAction = () => async (dispatch, getState) => {
  console.log("getactio");
  try {
    dispatch({
      type: GET_JOBLIST_REQUEST,
    });

    const {
      UserLogin: { token },
    } = getState();

    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };

    const { data } = await axios.get(`${API}/getJobList`, config);
    console.log("data:", data);

    dispatch({
      type: GET_ALLJOB_SUCCESS,
      payload: data,
    });
  } catch (error) {
    dispatch({ type: GET_JOBLIST_FAIL, payload: error.response.data.message || error.message });
  }
};

export const deleteNoteAction = (id) => async (dispatch, getState) => {
  try {
    dispatch({
      type: JOB_DELETE_REQUEST,
    });
    const {
      UserLogin: { token },
    } = getState();

    const config = {
      headers: {
        Authorization: `Bearer ${token.token}`,
      },
    };

    const { data } = await axios.delete(`${API}/getJobList/${id}`, config);

    dispatch({
      type: JOB_DELETE_SUCCESS,
      payload: data,
    });
  } catch (error) {
    const message = error.response && error.response.data.message ? error.response.data.message : error.message;
    dispatch({
      type: JOB_DELETE_FAIL,
      payload: message,
    });
  }
};
